// TODO: Move implementation to ClickToCopy
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Icon } from 'next/components/ui';
import useToggle from 'next/hooks/use-toggle';
import Fade from 'next/components/ui/lib/Fade';

const copyTextToClipboard = text => {
  navigator.clipboard.writeText(text);
};

const ClickContainer = styled.div`
  position: relative;
  width: fit-content;
`;

const FadeWrapper = styled(Fade)`
  display: block;
  position: absolute;
  top: -40px;
  width: max-content;
  right: 0;
`;

const Toast = styled.span`
  background-color: var(--copy-alert-bg);
  border-radius: 6px;
  color: var(--white);
  display: block;
  font-size: var(--regular);
  padding: 8px 16px;
`;

const StyledButton = styled(Button)`
  ${Icon} {
    margin-left: 10px;
    margin-right: 0;
    color: var(--profile-link-icon-color);
  }
`;

export function CopyButton({ value }) {
  const [visible, toggleVisible] = useToggle();

  useEffect(() => {
    if (!visible) {
      return;
    }

    const timer = setTimeout(() => {
      toggleVisible();
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timer);
    };
  }, [toggleVisible, visible]);

  const handleCopy = () => {
    copyTextToClipboard(value);
    toggleVisible();
  };

  return (
    <ClickContainer>
      <FadeWrapper visible={visible}>
        <Toast role="alert">Copied to clipboard</Toast>
      </FadeWrapper>
      <StyledButton kind="secondary" onClick={handleCopy}>
        Copy profile
        <Icon icon="clone" />
      </StyledButton>
    </ClickContainer>
  );
}

CopyButton.propTypes = {
  value: PropTypes.string,
};

export default CopyButton;
